import { targets } from "../../Context";
import SharedKillsHeatmap from "../shared/KillsHeatmap";

export default function KillsHeatmap(props: { target?: targets }) {
    return <SharedKillsHeatmap target={props.target ?? targets.competitive} />;
}
